import axios from "@/libs/api.request";
// 获取批量信息
export const getPayment = params => {
  return axios.request({
    url: "/finance/payment",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/finance/payment/${id}`,
    method: "GET"
  });
};
// 删除
export const del = id => {
  return axios.request({
    url: `/finance/payment/${id}`,
    method: "DELETE"
  });
};
// 修改
export const update = data => {
  return axios.request({
    url: `/finance/payment/${data.id}`,
    method: "PUT",
    data
  });
};
// 新增
export const add = data => {
  return axios.request({
    url: "/finance/payment",
    method: "POST",
    data
  });
};
